import { render, staticRenderFns } from "./archived-vacancies.vue?vue&type=template&id=7ceb118f&"
import script from "./archived-vacancies.vue?vue&type=script&lang=js&"
export * from "./archived-vacancies.vue?vue&type=script&lang=js&"
import style0 from "./archived-vacancies.vue?vue&type=style&index=0&id=7ceb118f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports